export enum ErrorCode {
  ERR404 = 'Not Found',
  ERR400 = 'Bad Request',
  ERR409 = 'Integrity Error',
  ERR415 = 'Unsupported File Format',
  ERR410 = 'Invalid Masquerade',
  ERR414 = 'Value for approvedAmount must be greate than Zero',
  ERR411 = 'Excel Export Failed',
  ERR420 = 'Invalid Section Parameter',
  ERR421 = 'Staff ID Required',
  ERR408 = 'Time expired',
  ERR502 = 'Connection Refused',
  ERR422 = 'Unprocessable Entity',
  ERR423 = 'Username exist',
  ERR442 = 'Preauth already used or doesnt exist',
  ERR443 = 'Invalid Search column found',
  ERR446 = 'StartDate mandatory for date range',
  ERR424 = 'Invalid input please provide valid data',
  ERR412 = 'Dialysis session is not conducted',
  ERR432 = 'Machines not available for slot allocation',
  ERR433 = 'Invalid Guest-Bedtype combination found',
  ERR434 = 'No record with Id found',
  ERR450 = 'Cognito user creation failed',
  ERR425 = 'Guest ID Required',
  ERR451 = 'Session not scheduled',
  ERR463 = 'Invalid Section Field',
  ERR413 = 'Price per session is not found or session price is already used',
  ERR416 = 'Invoice is already generated for this Center ID',
  ERR456 = 'Invalid or Unsupported Format',
  ERR418 = 'Another bill is already in pending state for this center please wait for some time to finish it',
  ERR468 = 'uniqueGuestId,startDate,endDate can not be null for guestSession report',
}
